// store/slices/paymentSlice.ts

export interface PendingCheckout {
  planName: string;
  billingCycle: "MONTHLY" | "ANNUAL";
}

export interface PaymentState {
  paymentSuccessSessionId: string | null;
  pendingCheckout: PendingCheckout | null;
}

export interface PaymentActions {
  setPaymentSuccessSessionId: (sessionId: string) => void;
  clearPaymentSuccessSessionId: () => void;
  setPendingCheckout: (checkout: PendingCheckout) => void;
  clearPendingCheckout: () => void;
}

export const paymentSlice = (
  set: any,
): { data: PaymentState; actions: PaymentActions } => ({
  data: {
    paymentSuccessSessionId: null,
    pendingCheckout: null,
  },
  actions: {
    setPaymentSuccessSessionId: (sessionId: string) => {
      set((state: any) => {
        state.data.paymentSuccessSessionId = sessionId;
      });
    },
    clearPaymentSuccessSessionId: () => {
      set((state: any) => {
        state.data.paymentSuccessSessionId = null;
      });
    },
    setPendingCheckout: (checkout: PendingCheckout) => {
      set((state: any) => {
        state.data.pendingCheckout = checkout;
      });
    },
    clearPendingCheckout: () => {
      set((state: any) => {
        state.data.pendingCheckout = null;
      });
    },
  },
});
